
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            @change="getMargins()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.InstrumentID"
            class="mx-1"
            :items="allInstrumentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="InstrumentTypeCode"
            item-value="InstrumentTypeID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Instrument"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.StartDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.StartDate"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getMargins()" color="#2A353D" v-model="parameters.StartDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.StartDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.EndDate"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getMargins()" color="#2A353D" v-model="parameters.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet v-if="trading_margins.length > 0" class="pb-3 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>

        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentTradingMargins"
                type    = "xls"
                name    = "Trading Position Report.xls">

                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentTradingMargins"
                type    = "csv"
                name    = "Trading Position Report.csv">

                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :fixed-header="true"
        :headers="liability_headers"
        :items="trading_margins.filter(t => t.Position == 'Liabilities')"
        :search="search"
        v-if="trading_margins.filter(t => t.Position == 'Liabilities').length > 0"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-container row>
            <span class="text-right subtitle-1 font-weight-bold mb-0 ml-4">Liabilities</span>
          </v-container>
        </template>
      </v-data-table>

      <v-data-table
        :fixed-header="true"
        :headers="asset_headers"
        :items="trading_margins.filter(t => t.Position == 'Assets')"
        :search="search"
        v-if="trading_margins.filter(t => t.Position == 'Assets').length > 0"
        hide-default-footer
        disable-pagination
        class="elevation-0 mt-2"
      >
        <template v-slot:top>
          <v-container row>
            <span class="text-right subtitle-1 font-weight-bold mb-0 ml-4">Assets</span>
          </v-container>
        </template>

        <!-- <template v-slot:item.Spread="{ item }">
          <v-chip outlined label v-if="item.Spread > '0'" color="success">{{item.Spread}}</v-chip>
          <v-chip outlined label v-else color="error">{{item.Spread}}</v-chip>
        </template> -->
      </v-data-table>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      trading_margins: [],
      CurrentTradingMargins: [],
      valid: true,
      search: '',
      message: '',
      menu: false,
      loading: false,
      permitted: null,
      permitted_dialog: true,
      heading: "Trading Position",
      menu2: false,
      liability_headers: [
        { text: 'Client', value: 'Seller', sortable: false, width: 200 },
        { text: 'DealDate', value: 'DealDate', sortable: false },
        { text: 'DealNote', value: 'DealNote', sortable: false },
        { text: 'Instrument', sortable: false, value: 'Instrument', align: 'start' },
        { text: 'Value', value: 'InstrumentValue', sortable: false },
        { text: 'Rate', value: 'ClientRate', sortable: false },
        { text: 'Tenor', value: 'Tenor', sortable: false },
        { text: 'Tax', value: 'Tax', sortable: false },
        { text: 'Interest', value: 'Interest', sortable: false },
        { text: 'Spread', value: 'Spread', sortable: false, align: 'end' },
        { text: 'MaturityValue', value: 'MaturityValue', sortable: false, align: 'end'}
      ],
      asset_headers: [
        { text: 'Seller', value: 'Seller', sortable: false, width: 200 },
        { text: 'DealDate', value: 'DealDate', sortable: false },
        { text: 'DealNote', value: 'DealNote', sortable: false },
        { text: 'Instrument', sortable: false, value: 'Instrument', align: 'start' },
        { text: 'Value', value: 'InstrumentValue', sortable: false },
        { text: 'Rate', value: 'DealRate', sortable: false },
        { text: 'Tenor', value: 'Tenor', sortable: false },
        { text: 'Tax', value: 'Tax', sortable: false },
        { text: 'Interest', value: 'Interest', sortable: false },
        { text: 'Spread', value: 'Spread', sortable: false, align: 'end' },
        { text: 'MaturityValue', value: 'MaturityValue', sortable: false, align: 'end'}
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts",
      "allInstrumentTypes",
      "allCounterparties"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts.filter(a => a.tblclient.CustodianID == this.parameters.CustodianID)
    }
  },

  created(){
    this.parameters = {
      InstrumentID: 0,
      SellerID: 0,
      StartDate: '2021-01-01',
      EndDate: this.currentSystemDate.DayDate
    }
    this.loading = true;
    reportsService.getTradingMargins(this.parameters)
    .then(response => {
      this.trading_margins = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getMargins() {
      if(this.parameters.InstrumentID == null || this.parameters.InstrumentID == ''){
        this.parameters.InstrumentID = 0
      }
      if(this.parameters.SellerID == null || this.parameters.SellerID == ''){
        this.parameters.SellerID = 0
      }
      if (this.parameters.StartDate != null && this.parameters.EndDate != null) {
        this.loading = true;
        reportsService.getTradingMargins(this.parameters)
        .then(response => {
          this.trading_margins = response.data;
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const liability_columns = [
        { title: 'Client', dataKey: 'Seller' },
        { title: 'DealDate', dataKey: 'DealDate' },
        { title: 'DealNote', dataKey: 'DealNote' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'Value', dataKey: 'InstrumentValue' },
        { title: 'Rate', dataKey: 'ClientRate' },
        { title: 'Tenor', dataKey: 'Tenor' },
        { title: 'Tax', dataKey: 'Tax' },
        { title: 'Interest', dataKey: 'Interest' },
        { title: 'Spread', dataKey: 'Spread' },
        { title: 'MaturityValue', dataKey: 'MaturityValue' }
      ];

      const asset_columns = [
        { title: 'Seller', dataKey: 'Seller' },
        { title: 'DealDate', dataKey: 'DealDate' },
        { title: 'DealNote', dataKey: 'DealNote' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'Value', dataKey: 'InstrumentValue' },
        { title: 'Rate', dataKey: 'DealRate' },
        { title: 'Tenor', dataKey: 'Tenor' },
        { title: 'Tax', dataKey: 'Tax' },
        { title: 'Interest', dataKey: 'Interest' },
        { title: 'Spread', dataKey: 'Spread' },
        { title: 'MaturityValue', dataKey: 'MaturityValue' }
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 6, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 6, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 6, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.InstrumentID > 0? 'Instrument: ' + this.allInstrumentTypes.filter(a => a.InstrumentTypeID == this.parameters.InstrumentID).map(a => a.InstrumentTypeCode) + '        ' : '') + (this.parameters.SellerID > 0? 'Seller: ' + this.allCounterparties.filter(a => a.CounterPartyID == this.parameters.SellerID).map(a => a.CounterPartyName) : ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.5, 8, 1.5);
          doc.setLineWidth(0.01).line(0.5, 1.7, 8, 1.7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);

      if(this.trading_margins.filter(t => t.Position == 'Liabilities').length > 0){
        doc.autoTable({
          columns: liability_columns,
          body: this.trading_margins.filter(t => t.Position == 'Liabilities'),
          margin: { left: 0.5, top: 1.5 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Liabilities", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        })
      }
      if(this.trading_margins.filter(t => t.Position == 'Assets').length > 0){
        doc.autoTable({
          columns: asset_columns,
          body: this.trading_margins.filter(t => t.Position == 'Assets'),
          margin: { left: 0.5, top: 1.5 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function() {
            doc.setFontSize(8);
            doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.27, 8, doc.autoTableEndPosY() + 0.27);
            doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.47, 8, doc.autoTableEndPosY() + 0.47);
            doc.text("Assets", 0.5, doc.autoTableEndPosY() + 0.2);
          },
          theme: 'plain'
        })
      }
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Trading Position Report.pdf')
      }
    },
    getFiltered(current){
      this.CurrentTradingMargins = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>